import { RestAPIClient } from "networks";
import { HTTPRequestMethods } from "networks/RestAPI/client";

import Paths from "./paths";
import {
  TakeSurvey,
  TakeSurveyCreateRequest,
  TakeSurveySchemaQuestionListRequest,
  TakeSurveySchemaQuestionListResponse,
} from "./types";

export const takeSurveyDetailService = (linkPath: string) =>
  RestAPIClient.call<TakeSurvey>({
    method: HTTPRequestMethods.GET,
    url: `${Paths.Detail}/${linkPath}`,
  });

export const takeSurveyCreateService = (params: TakeSurveyCreateRequest) =>
  RestAPIClient.call<unknown>({
    method: HTTPRequestMethods.POST,
    data: params,
    url: Paths.Create,
  });

export const takeSurveySchemaQuestionListService = (
  params: TakeSurveySchemaQuestionListRequest
) =>
  RestAPIClient.call<TakeSurveySchemaQuestionListResponse>({
    method: HTTPRequestMethods.GET,
    url: Paths.SchemaQuestionList,
    config: {
      params,
      requireAuthentication: true,
    },
  });
